export const CREATE_GOAL_SUCCESS = {
  message: 'Goal created successfully!',
  type: 'is-success',
};

export const CREATE_GOAL_ERROR = {
  message: 'Oops! There was an error creating your goal. Try again later.',
  type: 'is-danger',
};

export const EDIT_GOAL_SUCCESS = {
  message: 'Goal edited successfully!',
  type: 'is-success',
};

export const EDIT_GOAL_ERROR = {
  message: 'Oops! There was an error while editing your goal. Try again later.',
  type: 'is-danger',
};

export const UPDATE_USER_PROFILE_SUCCESS = {
  message: 'Profile edited successfully!',
  type: 'is-success',
};

export const UPDATE_USER_PROFILE_ERROR = {
  message: 'Oops! There was an error while editing this user profile. Try again later.',
  type: 'is-danger',
};

export const ARCHIVE_USER_ERROR = {
  message: 'Oops! There was an error while archiving this user profile. Try again later.',
  type: 'is-danger',
};

export const ARCHIVE_USER_SUCCESS = {
  message: 'User archived successfully!',
  type: 'is-success',
};

export const UPDATE_TEAM_SUCCESS = {
  message: 'Team updated successfully!',
  type: 'is-success',
};

export const UPDATE_TEAM_ERROR = {
  message: 'Oops! There was a problem while updating this team. Try again later.',
  type: 'is-danger',
};

export const RESEND_INVITATION_SUCCESS = userEmail => ({
  message: `You've successfully re-sent an invitation to ${userEmail}!`,
  type: 'is-success',
});

export const RESEND_INVITATION_ERROR = userEmail => ({
  message: `Oops! there was a problem while re-sending an invitation to ${userEmail}!`,
  type: 'is-danger',
});

export const DELETE_INVITATION_SUCCESS = userEmail => ({
  message: `You've successfully deleted an invitation to ${userEmail}!`,
  type: 'is-success',
});

export const DELETE_INVITATION_ERROR = userEmail => ({
  message: `Oops! there was a problem while deleting an invitation to ${userEmail}!`,
  type: 'is-danger',
});


export const UPGRADE_SUBSCRIPTION_SUCCESS = {
  message: 'You\'ve successfully updated your subscription',
  type: 'is-success',
};

export const SLACK_CONNECT_ERROR = {
  message: 'Oops! There was an error while connecting to slack.  Try again later.',
  type: 'is-danger',
};

export const SLACK_JOIN_CHANNEL_WARN = channel => ({
  message: `Slack connected but could not automatically join <strong>#${channel}</strong>.  Please invite @StandupPro to this channel`,
  type: 'is-warning',
});
